import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';
import InvestmentObjectiveTimeHorizons
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/AumInformation/investmentObjectiveTimeHorizons';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  AUMResponsesOverride,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/aumResponses/metaOverrideSet';
import OnboardingPlannerViewSectionHeader
  from '../../Components/OnboardingPlannerViewSectionHeader';

export function AUMResponsesLayout() {
  const {
    resource,
  } = useMetaLayoutContext();
  const sectionData = resource.attr('sectionData').resources().head();
  return (
    <>
      <FDStack paddingX={3} direction="column" spacing={2}>
        <OnboardingPlannerViewSectionHeader title={resource.attr('title')} />
        <MetaControl resource={sectionData} metaOverrideSet={AUMResponsesOverride} attrName="prospectCurrentlyHasAum" />
        <MetaControl resource={sectionData} metaOverrideSet={AUMResponsesOverride} attrName="prospectPlansToInvest" />
        <MetaControl resource={sectionData} metaOverrideSet={AUMResponsesOverride} attrName="reasonProspectWillNotInvest" />
        <MetaControl resource={sectionData} metaOverrideSet={AUMResponsesOverride} attrName="otherReasonProspectWillNotInvest" />
        <InvestmentObjectiveTimeHorizons />
      </FDStack>
    </>
  );
}
